(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    $('#wrapper > #content .component.profile-spot').each(function () {
      var $this = $(this);
    });
    window.DGS.EqualHeight.getInstance().register($('#wrapper > #content .component.profile-spot .info-box'));
  });
})(jQuery);